import { render } from "./AccountingSettingsTableView.vue?vue&type=template&id=8684fdb8&scoped=true&ts=true&lang=pug"
import script from "./AccountingSettingsTableView.vue?vue&type=script&lang=ts"
export * from "./AccountingSettingsTableView.vue?vue&type=script&lang=ts"

import "./AccountingSettingsTableView.vue?vue&type=style&index=0&id=8684fdb8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8684fdb8"]])

export default __exports__